import React, { useEffect } from 'react';
import { HeadingText, BodyText, Button, PAYPAL_THEME, Row, Col } from '@paypalcorp/pp-react';
import { parseMessages } from '../../utilityHelper';
import * as FPT from '../../utility/fpt';
import { get } from 'lodash';
const { sysColorBackgroundMediumContrast } = PAYPAL_THEME;

export const GetStartProfile = (props) => {
    const messages = get(parseMessages('givingfund'), `profile.getstart.${props.version}`);
    useEffect(() => {
        FPT.trackPage(props.version == 'manual' ? 'main:givingfund:getStartEnroll' : 'main:givingfund:getStartProfile');
    }, []);
    return (
        <div style={props.version == 'manual' ? { margin: "3rem auto", maxWidth: "50rem" } : { margin: "0 3rem" }}>
            <Row>
                <Col style={{ textAlign: 'center' }}>
                    <img src="https://www.paypalobjects.com/paypal-ui/illustrations/focused/svg/empty-document-white.svg" alt="" style={{ width: "9rem" }} />
                    <HeadingText size="lg" style={{ margin: "1.5rem 0" }}>{messages.head}</HeadingText>
                </Col>
            </Row>
            <Row>
                <Col>
                    <BodyText style={{ color: sysColorBackgroundMediumContrast }}>{messages.description}</BodyText>
                    <div className="profileList">
                        <BodyText style={{ margin: "1.125rem 0" }} strong>{messages.actions.head}</BodyText>
                        <ul>
                            <li><BodyText className="listElement">{messages.action1}</BodyText></li>
                            <li><BodyText className="listElement" style={{ margin: "1.5rem 0" }}>{messages.action2}</BodyText></li>
                            <li><BodyText className="listElement">{messages.action3}</BodyText></li>
                        </ul>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col style={{ textAlign: 'center' }}>
                    <Button data-fpti={props.version == 'manual' ? 'getStartEnroll' : 'getStartProfile'} id="getStartedBtn" onClick={() => props.setProfileEditView('profile', 'editProfileBtn')} style={{ marginTop: "3rem" }}>{messages.action.button}</Button>
                </Col>
            </Row>
        </div>
    )
}